// Son d'alerte à l'arrivée d'une notification, dans l'application ouverte (site, iPhone, Android,
// ordinateur). Les navigateurs n'autorisent le son qu'après un premier geste de l'utilisateur :
// le contexte audio est débloqué au premier toucher, clic ou touche du clavier.
import { isAndroidApp, isWindowsApp } from "../platform";

export const CLE_SON_NOTIFICATIONS = "ql_son_notifications";
let contexte = null;
let dernierSon = 0;
let notificationSystemeActive = false;

function obtenirContexte() {
  const Api = window.AudioContext || window.webkitAudioContext;
  if (!Api) return null;
  if (!contexte) {
    try { contexte = new Api(); } catch { return null; }
  }
  if (contexte.state === "suspended") contexte.resume?.().catch?.(() => {});
  return contexte;
}

export function installerSonAlerte() {
  const debloquer = () => {
    const ctx = obtenirContexte();
    if (ctx && ctx.state === "running") {
      ["pointerdown", "touchend", "keydown"].forEach((e) => window.removeEventListener(e, debloquer, true));
    }
  };
  ["pointerdown", "touchend", "keydown"].forEach((e) => window.addEventListener(e, debloquer, true));
}

// Sur Android et sur l'application d'ordinateur, la notification système sonne déjà :
// pas de second son quand elle a été autorisée.
export function signalerNotificationSysteme(active) {
  notificationSystemeActive = !!active && (isAndroidApp || isWindowsApp);
}

export function sonActive() {
  try { return window.localStorage.getItem(CLE_SON_NOTIFICATIONS) !== "false"; } catch { return true; }
}

// forcer : essai depuis les Paramètres (le geste de l'utilisateur débloque aussi le son).
export function jouerSonAlerte({ forcer = false } = {}) {
  if (!forcer && (notificationSystemeActive || !sonActive())) return false;
  const maintenant = Date.now();
  if (!forcer && maintenant - dernierSon < 3000) return false;
  const ctx = obtenirContexte();
  if (!ctx || ctx.state !== "running") return false;
  dernierSon = maintenant;
  try {
    // Deux notes brèves et montantes (mi, la).
    [[659, 0], [880, 0.14]].forEach(([frequence, decalage]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const debut = ctx.currentTime + decalage;
      osc.type = "sine";
      osc.frequency.value = frequence;
      gain.gain.setValueAtTime(0.0001, debut);
      gain.gain.exponentialRampToValueAtTime(0.25, debut + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, debut + 0.3);
      osc.connect(gain).connect(ctx.destination);
      osc.start(debut);
      osc.stop(debut + 0.32);
    });
    return true;
  } catch { return false; }
}

// Le nombre de notifications non lues a augmenté depuis la dernière lecture : une nouvelle est arrivée.
let dernierTotal = null;
export function suivreNotificationsNonLues(total) {
  if (typeof total !== "number") return false;
  const nouvelle = dernierTotal !== null && total > dernierTotal;
  dernierTotal = total;
  return nouvelle ? jouerSonAlerte() : false;
}

export function reinitialiserSonAlertePourTests() {
  dernierTotal = null; dernierSon = 0; notificationSystemeActive = false; contexte = null;
}
